import React from 'react';

const linkTo = (href, text) =>
  text ? (
    <a href={href} style={{ color: '#1a73c8', textDecoration: 'underline' }}>
      {text}
    </a>
  ) : (
    <span>—</span>
  );

const userRoleAssignmentConfig = {
  name: 'User Role Assignment',
  endpoint: '/internal_admin/admin_kit/user_role_assignments',
  modelKey: 'rbac_user_role_assignment',

  columns: [
    { name: 'user_email', title: 'User', type: 'link' },
    { name: 'role_name', title: 'Role' },
    { name: 'account_name', title: 'Account' },
    { name: 'discarded_at', title: 'Discarded' },
    { name: 'created_at', title: 'Created' },
  ],

  filters: [
    { name: 'q[user_email_cont]', label: 'User Email' },
    { name: 'q[role_name_cont]', label: 'Role' },
    { name: 'q[account_name_cont]', label: 'Account' },
  ],

  attributes: [
    { name: 'id', label: 'ID' },
    {
      name: 'user_email',
      label: 'User',
      render: (r) => linkTo(`/internal_admin/admin_kit/users/${r.user_id}`, r.user_email),
    },
    {
      name: 'role_name',
      label: 'Role',
      render: (r) => linkTo(`/internal_admin/admin_kit/roles/${r.role_id}`, r.role_name),
    },
    {
      name: 'account_name',
      label: 'Account',
      render: (r) => linkTo(`/internal_admin/admin_kit/dealers/${r.account_id}`, r.account_name),
    },
    { name: 'discarded_at', label: 'Discarded At' },
    { name: 'created_by_name', label: 'Created By' },
    { name: 'created_at', label: 'Created At' },
    { name: 'updated_at', label: 'Updated At' },
  ],

  form: {
    fields: [
      {
        name: 'user_id',
        label: 'User',
        type: 'typeahead',
        searchEndpoint:
          '/internal_admin/admin_kit/user_role_assignments/user_search',
        displayField: 'user_email',
        required: true,
      },
      {
        name: 'role_id',
        label: 'Role',
        type: 'typeahead',
        searchEndpoint:
          '/internal_admin/admin_kit/user_role_assignments/role_search',
        displayField: 'role_name',
        required: true,
      },
      {
        name: 'account_id',
        label: 'Account',
        type: 'typeahead',
        searchEndpoint:
          '/internal_admin/admin_kit/user_role_assignments/account_search',
        displayField: 'account_name',
        required: true,
      },
    ],
  },
};

export default userRoleAssignmentConfig;
